<template>
    <div>
        <v-card class="card--flex-toolbar" flat>
            <v-tabs color="grey lighten-3" v-model="current_tab" dark slider-color="grey darken-4">
                <v-tab ripple v-for="tab in tabs" :key="tab.href" :to="{name: tab.route_name}" class="grey--text text--darken-4 caption">{{tab.text}}</v-tab>
            </v-tabs>
        </v-card>
        <v-card v-if="isLoading" height="50vh">
            <v-content class="content-background">
                <v-container fluid fill-height>
                    <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                    </v-flex>
                    </v-layout>
                </v-container>
            </v-content>
        </v-card >
        <router-view v-else :company="company"></router-view>
    </div>
</template>

<script>
import i18n from "@/i18n";
import DEFINES from '@/defines';
import { mapState, mapGetters } from "vuex";
export default {
    name: 'SubscriptionIndex',
    data() {
        return {
            active: null,
            current_tab: 'overview',
            company: null,
            members: null,
            mailchimpLists: [],
            isLoading: false,
            tabs: [
                {
                    text: i18n.t('subscription.title'),
                    route_name: 'subscription.list'
                },
                {
                    text: i18n.t('company.subscription.plans.title'),
                    route_name: 'subscription.plans'
                },
            ]
        }
    },
    created() {
        this.bootstrap();
    },
    computed: {
        ...mapGetters("company", {
            selected_company_id: "getSelected",
        }),
    },
    methods: {
       async bootstrap() {
            this.isLoading = true;
            await Promise.all([
                this.$store.dispatch("company/get", {
                    id: this.$route.params.company_id
                }),
                this.$store.dispatch("company/getMembers", {
                id: this.$route.params.company_id,
                })
            ])
            .then((responses) => {
                this.company = responses[0];
                this.members = responses[1].members
            }).catch((error) => {
                this.$store.dispatch("app/showMessage", {
                message: error.message,
                color: "error"
                });
            })
            .finally(() => {
                this.isLoading = false
            })
        }
    }
}
</script>
